import { defineStore } from "pinia";
import axios from "axios";
import { useUserStore } from './UserStore'

export const useDicStore = defineStore('DicStore', {
    state: () => {
        return {
            dic: [],
            vershina_links: [],
            b2b_news: {
                data : {},
                is_loading : false,
                modal: {},
            },
            ui_el: [],
            goods_types: [],
            promo: {
                data : {},
                is_loading : false,
                modal: {},
            },
        }
    },
    actions:{
        async fill(){
            const userStore = useUserStore()
            this.dic = (await axios.get('/api/GetDictionary/notice_b2b', {
                withCredentials: true,
            })).data;

            if(typeof(this.dic.error) != "undefined" && (this.dic.error !== null) && (this.dic.error == true)) {
                console.log('Error Get Dictionary Data');
            }
        },
        async fill_promo(){
            this.promo.is_loading = true;
            const userStore = useUserStore()
            let reqResult = (await axios.get('/api/GetDictionary/promo?order=desc', {
                withCredentials: true,
            })).data;

            if(typeof(reqResult.error) != "undefined" && (reqResult.error !== null) && (reqResult.error === true)) {
                console.log('Error Get Promo Data');
            }
            else
            {
                this.promo.data = reqResult.results;

            }
            this.promo.is_loading = false;
        },
        async fill_vershina_links(){
            const userStore = useUserStore()
            this.vershina_links = (await axios.get('/api/GetDictionary/vershina_links', {
                withCredentials: true,
            })).data;

            if(typeof(this.vershina_links.error) != "undefined" && (this.vershina_links.error !== null) && (this.vershina_links.error == true)) {
                console.log('Error Get Vershina_links Data');
            }
        },

        async fill_b2b_news(){
            this.promo.is_loading = true;

            this.b2b_news.data = (await axios.get('/api/GetDictionary/b2b_news?order=desc', {
                withCredentials: true,
            })).data;

            if(typeof(this.b2b_news.data.error) != "undefined" && (this.b2b_news.data.error !== null) && (this.b2b_news.data.error == true)) {
                console.log('Error Get b2b_news Data');
            }
        },

        async fill_ui_el(){
            const userStore = useUserStore()
            this.ui_el = (await axios.get('/api/GetDictionary/ui_el_b2b', {
                withCredentials: true,
            })).data;

            if(typeof(this.ui_el.error) != "undefined" && (this.ui_el.error !== null) && (this.ui_el.error == true)) {
                console.log('Error Get ui_el_b2b Data');
            }
        },
    }
})
